<template>
  <app-landing-page-layout>
    <div class="flex h-screen overflow-y-auto">
      <div class="mx-auto mt-12">
        <div class="flex justify-center">
          <img class="w-24" src="/static/logos/parlay_logo.svg" alt="" />
        </div>
        <div
          class="sign-in-box my-5 box-border shadow-sm p-9 border-1 rounded bg-white"
        >
          <p class="mb-4 flex justify-center font-bold text-lg">New Password</p>
          <div>
            <label class="font-semibold">Enter a new password</label>
            <password
              v-model="new_pwd"
              :badge="false"
              :toggle="true"
              @keyup.native="error_msg = null"
            />
            <div class="password-text text-gray-400 leading-3">
              Use 8 ore more characters with a mix of letters, numbers &
              symbols.
            </div>
          </div>
          <div class="mt-2">
            <label class="font-semibold">Re-enter your password</label>
            <input
              v-model="repeat_pwd"
              @keyup.native="error_msg = null"
              type="password"
              class="bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded"
            />
          </div>
          <div class="h-5 text-xs text-red-500 italic">
            {{ error_msg }}
          </div>
          <button
            class="px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold"
            @click="submitPassword"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    <pl-dialog
      v-if="show_modal"
      header="Password has been reset"
      @close="closeDialog"
    >
      <p style="padding-left: 18px">
        You are now able to login with your new credentials.
      </p>
      <div class="end-xs" style="padding-top: 10px">
        <pl-button @click.native="closeDialog" class="pl-primary"
          >Back to login</pl-button
        >
      </div>
    </pl-dialog>
  </app-landing-page-layout>
</template>

<script>
  import authenticationServices from 'features/authentication/authentication.services';
  import 'features/authentication/authentication.styles.styl';
  import Password from 'vue-password-strength-meter';

  export default {
    data() {
      return {
        new_pwd: '',
        repeat_pwd: '',
        error_msg: null,
        show_modal: false,
      };
    },
    components: {
      appLandingPageLayout: require('layouts/appLandingPage/appLandingPage.vue'),
      Password,
    },
    methods: {
      closeDialog() {
        this.show_modal = false;
        this.$router.push('/account/login');
      },
      submitPassword() {
        if (!this.new_pwd || this.new_pwd.length < 8) {
          this.error_msg =
            'Please enter a password at least 8 characters in length';
          return;
        }
        if (
          this.new_pwd &&
          this.repeat_pwd &&
          this.new_pwd === this.repeat_pwd
        ) {
          const payload = {
            new_password: this.new_pwd,
            token: this.$route.query.token,
          };
          authenticationServices
            .newPassword(payload)
            .then(() => {
              this.show_modal = true;
            })
            .catch((err) => {
              this.error_msg =
                'Something went wrong. Refresh the page and try again';
              console.error(err);
            });
        } else {
          this.error_msg =
            'New password and re-entry of password need to match';
        }
      },
    },
    mounted() {
      // if url doesnt have a token then go to login page
      if (!this.$route.query.token) {
        this.$router.push('/account/login');
      }
    },
  };
</script>

<style scoped lang="stylus">
  .sign-in-box
    width: 500px
    @media (max-width: 639px)
      width: 100vw
  .password-text
    font-size: 10px
</style>
<style lang="scss">
  .Password {
    max-width: 100% !important;
    .Password__field {
      padding: 8px 16px;
      background-color: rgba(243, 244, 246, 1) !important;
      height: 36px;
      font-size: 12px;
      border: 0;
      border-radius: 4px;
    }
    .Password__strength-meter {
      margin: 5px 0 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// newPwd.vue?8314334e